import React from "react";
import { Box, Grid } from "@mui/material";
import LoginForm from "../form/LoginForm";
import LoadingModal from "../components/reusableComponents/LoadingModal";

const LoginPage = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${"https://agent.goflysmart.com/img/base/background.jpg"})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: "background-image 300ms ease-in 200ms",
        minHeight: "100vh",
      }}
    >
      <Grid container style={{ paddingTop: 80,paddingLeft:10,paddingRight:10 }}>
        <Grid item xs={12} lg={4}></Grid>
        <Grid
          item
          xs={12} lg={4}
          style={{
            background: "#fff",
            boxShadow: "0 10px 15px rgba(0,0,0,.1)",
            padding: 40,
            borderRadius: 2,
          }}
        >
          <LoginForm />
        </Grid>
        <Grid item xs={12} lg={4}></Grid>
      </Grid>
      <Box style={{ textAlign: "center" }}>
        <p style={{ color: "white" }}>
          Contact Us<br></br>
          +91 887-777-3388
        </p>
      </Box>
      <LoadingModal/>
    </div>
  );
};

export default LoginPage;
